<template>
  <a
    v-bind="{'xlink:href': link }"
  >
    <polygon
      v-if="shape.polygon"
      :key="'polygon-' + shape.id"
      :points="shape.polygon"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
    <path
      v-else
      :key="'path-' + shape.id"
      :d="shape.path"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
  </a>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// VUEX Models
import Availability from '@/models/Availability';
import Building from '@/models/Building';
import Illustration from '@/models/Illustration';
import Residence from '@/models/Residence';
import Shape from '@/models/Shape';

export default {
  name: 'Shape',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data: function() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    shape() {
      return Shape.find(this.id);
    },
    residence() {
      if (this.type === 'residences') {
        return Residence.query()
          .with('availability')
          .find(this.shape.shapeable_id);
      } else {
        return { availability: false, id: false, };
      }
    },
    building() {
      if (this.type === 'buildings') {
        return Building.query()
          .with('availability')
          .find(this.shape.shapeable_id);
      } else {
        return { availability: false, id: false, };
      }
    },
    availability() {
      if (this.type === 'residences') {
        return Availability.find(this.residence.availability_id);
      } else if (this.type === 'buildings') {
        return Availability.find(this.building.availability_id);
      } else {
        return false;
      }
    },
    css() {
      const availability = this.availability;
      let classes = '';
      if (availability !== false) {
        classes += 'is-' + availability.slug;
      } else {
        classes += 'is-none';
      }
      if (this.hasFocus === true) {
        classes += ' has-focus';
      }
      if (this.type === 'buildings') {
        classes += ' is-building';
      } else if (this.type === 'residences') {
        classes += ' is-residence';
      }
      return classes;
    },
    link() {
      if (this.building.url) {
        return this.building.url;
      } else {
        return false;
      }
    },
  },
  created() {
    if (this.type === 'residences') {
      EventBus.$on('residence-focus', focus => {
        if (focus.id === this.residence.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    } else if (this.type === 'buildings') {
      EventBus.$on('building-focus', focus => {
        if (focus.id === this.building.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    }
  },
  methods: {
    toggleFocus(focus) {
      if (this.type === 'residences') {
        EventBus.$emit('residence-focus', {
          hasFocus: focus,
          id: this.residence.id,
          name: this.residence.name,
          illustrationIds: [],
        });
      } else if (this.type === 'buildings') {
        EventBus.$emit('building-focus', {
          hasFocus: focus,
          id: this.building.id,
          name: this.building.name,
        });
      }
      if (this.type === 'residences') {
        this.scrollResidenceIntoView(this.residence.slug);
      }
    },
    updateRouter() {
      this.toggleFocus(false);
      if (this.type === 'residences') {
        this.$router.push({
          name: 'bolig',
          params: { slug: this.residence.slug, },
        });
      } else {
        if (this.link === false) {
          this.updateSelectedBuilding();
        }
      }
    },
    scrollResidenceIntoView(element) {
      const residence = document.getElementById(element);
      if (residence) {
        const residenceList = document.getElementById('residenceList');
        const offset = residence.offsetTop;
        residenceList.scrollTo({ top: offset, behavior: 'smooth', });
      }
    },
    updateSelectedBuilding() {
      Building.commit(state => {
        state.selectedBuilding = this.shape.shapeable_id;
      });
      Illustration.commit(state => {
        state.currentSection = this.shape.shapeable_id;
      });
      localStorage.setItem('selectedBuilding', this.shape.shapeable_id);
    },
  },
};
</script>

